import { InMemoryCache } from '@apollo/client';
import { GET_USER_STATUS } from 'graphqls/profile';

export const initializeIsVerified = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_USER_STATUS,
    data: {
      isVerified: false,
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      setUserVerified: (_, args, { cache }): null => {
        cache.writeQuery({
          query: GET_USER_STATUS,
          data: {
            __typename: 'isVerified',
            isVerified: args.isVerified,
          },
        });

        return null;
      },
    },
  },
};
